import { SocialLinks } from "../components/SocialLinks";
import logo from "../images/Logo.svg";
import underlay from "../textures/Autumn.svg";

export const Construction = () => {
  return (
    <section
      className={"h-screen bg-light-2 dark:bg-dark-3 bg-transparent"}
      style={{ backgroundImage: `url(${underlay})` }}
    >
      <div
        className={
          "flex flex-col items-center justify-center place-self-center pt-6"
        }
      >
        <img className={"flex w-1/2"} src={logo} alt={"logo"} />
        <h1
          className={
            "flex text-center text-2xl lg:text-4xl font-bold text-secondary-200 dark:text-primary-500"
          }
        >
          Little Layers LLC
        </h1>
        <ul
          className={
            "flex flex-col items-center text-center gap-4 px-6 mt-6 mb-8 text-sm lg:text-2xl text-secondary-500 dark:text-primary-800"
          }
        >
          <li className={"text-xl lg:text-4xl font-medium"}>
            Under Construction
          </li>
          <li>Our website is still being built.</li>
          <li>If you need to contact us, you can reach out to us at:</li>
          <li>
            <a href="mailto:littlelayers.wi@gmail.com?Subject=I love cake!">
              littlelayers.wi@gmail.com
            </a>
          </li>
        </ul>
        <SocialLinks
          facebookLink={
            "https://www.facebook.com/share/14vUDTKxC1Q/?mibextid=wwXIfr"
          }
          instagramLink={"https://www.instagram.com/littlelayersmukwonago"}
        />
      </div>
    </section>
  );
};

export default Construction;
